export enum InputPhonenumberPrefixTypeEnum {
    National,
    InternationalZeros,
    InternationalPlus,
}
